import { ALI_PLAY_AUTH, ALI_PLAY_AUTH_NOT_LOGIN, CC_AUTH } from '@constants/api';
import _axios from '@plugins/_axios';
import store from '@/store';

/**
 * 获取阿里视频认证
 * @param {String} video_id 视频ID
 */
export function getAliPlayAuth(video_id) {
    const token = store.getters.token;
    const url = token ? ALI_PLAY_AUTH : ALI_PLAY_AUTH_NOT_LOGIN;
    return _axios.get(url, {
        params: {
            video_id
        }
    });
}

/**
 * 获取CC播放器授权
 */
export function getCCAuth() {
    return _axios.post(CC_AUTH);
}
